import { TableNode, type SerializedTableNode } from "@lexical/table";
import type { EditorConfig, LexicalNode, NodeKey } from "lexical";

type SerializedDataTableNode = SerializedTableNode & {
  type: "data-table";
  border?: string;
  cellPadding?: string;
};

export class DataTableNode extends TableNode {
  __border: string;
  __cellPadding: string;

  constructor(border?: string, cellPadding?: string, key?: NodeKey) {
    super(key);
    this.__border = border ?? "none";
    this.__cellPadding = cellPadding ?? "1px";
  }

  static getType(): string {
    return "data-table";
  }

  static clone(node: DataTableNode): DataTableNode {
    return new this(node.__border, node.__cellPadding, node.__key);
  }

  exportJSON(): SerializedDataTableNode {
    return {
      ...super.exportJSON(),
      type: "data-table",
      border: this.__border,
      cellPadding: this.__cellPadding,
    };
  }

  static importJSON(serializedNode: SerializedDataTableNode): DataTableNode {
    return new DataTableNode(serializedNode.border, serializedNode.cellPadding);
  }

  createDOM(config: EditorConfig): HTMLTableElement {
    const dom = super.createDOM(config);
    dom.classList.add("data-table");
    return dom as HTMLTableElement;
  }
}

export function $createDataTableNode(border?: string, cellPadding?: string): DataTableNode {
  return new DataTableNode(border, cellPadding);
}

export function $isDataTableNode(node: LexicalNode | null | undefined): node is DataTableNode {
  return node instanceof DataTableNode;
}
